import { cn } from "@/lib/utils";

type EstadoPeriodo = "abierto" | "cerrado_tienda" | "liquidado" | "pagado" | "anulado";

interface EstadoBadgeProps {
  estado: EstadoPeriodo;
  className?: string;
}

const LABELS: Record<EstadoPeriodo, string> = {
  abierto: "Abierta",
  cerrado_tienda: "Esperando liquidación",
  liquidado: "Liquidada",
  pagado: "Pagada",
  anulado: "Anulada",
};

const STYLES: Record<EstadoPeriodo, string> = {
  abierto: "bg-state-abierto/15 text-state-abierto border-state-abierto/30",
  cerrado_tienda: "bg-state-cerrado/15 text-state-cerrado border-state-cerrado/30",
  liquidado: "bg-state-liquidado/15 text-state-liquidado border-state-liquidado/30",
  pagado: "bg-state-pagado/15 text-state-pagado border-state-pagado/30",
  anulado: "bg-state-anulado/15 text-state-anulado border-state-anulado/30",
};

export function EstadoBadge({ estado, className }: EstadoBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-pill border px-2.5 py-1 text-xs font-medium",
        STYLES[estado],
        className,
      )}
    >
      <span className="size-1.5 rounded-full bg-current" />
      {LABELS[estado]}
    </span>
  );
}
